// extracted by mini-css-extract-plugin
export default {"title":"Billing_title__u-+fd","wrapper":"Billing_wrapper__ef2xC","section":"Billing_section__m97EW"};